import { render, staticRenderFns } from "./AppAgeGate.vue?vue&type=template&id=6d712929&scoped=true&"
import script from "./AppAgeGate.vue?vue&type=script&lang=ts&"
export * from "./AppAgeGate.vue?vue&type=script&lang=ts&"
import style0 from "./AppAgeGate.vue?vue&type=style&index=0&id=6d712929&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d712929",
  null
  
)

export default component.exports